module.exports = __webpack_public_path__ + "static/media/loc6_img12.5d3020a8.jpg";